import { useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import { useDispatch, useSelector } from 'react-redux'
import Notice from '../../components/common/ui/Notice'
import PaginationLinks from '../../components/common/ui/Pagination/PaginationLinks'
import PaginationStats from '../../components/common/ui/Pagination/PaginationStats'
import Search from '../../components/common/ui/Search'
import { obituaryStore } from '../store/root'
import ObituaryItem from './ObituaryItem'
import PropTypes from 'prop-types'

function ObituaryList({ props, searchQueryParam }) {

    const {
        obituaryFullList,
        obituaryFullFetchAllLoading,
        obituaryFullFetchAllError
    } = useSelector(state => state.obituaryFullReducer)

    const { currentPage, searchQuery } = useSelector(state => state.navigation)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!searchQueryParam || searchQueryParam === searchQuery) {
            dispatch(obituaryStore.obituaryFull.services.findAll({
                ...{ page: currentPage },
                ...(searchQuery && { q: searchQuery }),
                ...(props.limit && { per_page: props.limit }),
            }))
        }
    }, [currentPage, searchQuery])

    return (
        <>
            <Search title={"obituaries"} />

            <PaginationStats pager={obituaryFullList} />

            {!obituaryFullFetchAllLoading ? (
                <>
                    {obituaryFullFetchAllError ? (
                        <Notice type="notice" description="Invalid Configuration. Please contact your administrator." />
                    ) : (
                        <>
                            {obituaryFullList.data && obituaryFullList.data.length ? (
                                <>
                                    <div className="grid grid-cols-1 gap-6 mb-4 obituary-list">
                                        {obituaryFullList.data.map((obituary, i) => (
                                            <ObituaryItem obituary={obituary} photoShape={props.photoShape} target={props.target} showFlowersIcon={props.showFlowersIcon} key={i} />
                                        ))}
                                    </div>
                                </>
                            ) : (
                                <>No obituaries found</>
                            )}
                        </>
                    )}
                </>
            ) : (
                <Skeleton height={25} count={3} />
            )}

            <PaginationLinks pager={obituaryFullList} />
        </>
    )
}

ObituaryList.propTypes = {
    props: PropTypes.object,
    searchQueryParam: PropTypes.string
}

export default ObituaryList